import {useTranslation} from "react-i18next";

export const useTaxConfigurationAccordionValues = () => {

    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'taxConfiguration'});

    const reservationValues = [{
        label: t('form.reservedPricingFieldValues.reserved'),
        value: 'RESERVED'
    }, {
        label: t('form.reservedPricingFieldValues.notReserved'),
        value: 'NOTRESERVED'
    }];

     const surchargesValues = [
        {
            label: t('form.surchargesValues.Z'),
            value: 'Z'
        },
        {
            label: t('form.surchargesValues.N'),
            value: 'N'
        },
        {
            label: t('form.surchargesValues.S'),
            value: 'S'
        },
    ];


    return {
        reservationValues,
        surchargesValues
    }
}